import React from 'react';
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss';

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="March 2024 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Senior Full-Stack Software Engineer
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a
                href="https://bazaarcheap.com/"
                style={{
                  textDecoration: 'none',
                  color: '#0B70B8',
                }}
              >
                BazaarCheap
              </a>
            </h4>
            <h4 className="vertical-timeline-element-subtitle">
              Kampala, Uganda
            </h4>
            <p>Senior Front-end Developer and UX/UI Designer</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Aug 2023 - Sept 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Intern Junior Software Engineer
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a
                href="https://www.nwsc.co.ug/"
                style={{
                  textDecoration: 'none',
                  color: '#0B70B8',
                }}
              >
                Uganda National Water and Sewerage Corporation (NWSC){' '}
              </a>
            </h4>
            <p>
              Intern Backend Development, Systems Administration, Computing
              Electronics
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="March 2022 - March 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Junior Full Stack Software Engineer
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a
                href="https://bazaarcheap.com/"
                style={{
                  textDecoration: 'none',
                  color: '#0B70B8',
                }}
              >
                BazaarCheap
              </a>
            </h4>
            <p>Full-stack Development, API Development, User Experience</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Aug 2021 - March 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Junior Full Stack Software Engineer Trainee
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a
                href="https://bazaarcheap.com/"
                style={{
                  textDecoration: 'none',
                  color: '#0B70B8',
                }}
              >
                BazaarCheap
              </a>
            </h4>
            <p>Full-stack Development, API Development, User Experience</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
